<template>
    <div class="container-fluid" @click="close">
        <div id="mymodal-image" :class="['modal-image', image !== null ? 'bg' : '']" v-if="image !== null">
            <div id="mediaImagePreviewImage" class="modal-image-content" :style="`background-image: url('${this.image}')`"></div>
        </div>
    </div>
</template>

<script>
import {EVENT_MEDIA_PREVIEW_IMAGE} from "@/core/constants";
import MediaApiService from "@/api/media.api";

export default {
    name: "MediaImagePreview",

    data() {
        return {
            image: null
        }
    },

    mounted() {
        this.$eventBus.$on(EVENT_MEDIA_PREVIEW_IMAGE, this.resolvePreview);
    },

    destroyed() {
        this.$eventBus.$off(EVENT_MEDIA_PREVIEW_IMAGE);
    },

    methods: {
        resolvePreview(mediaItem) {
            let loader = this.$loading.show();
            MediaApiService.previewImage(mediaItem.path)
                .then(response => {
                    this.image = `data:${response.data.type};base64,${response.data.image}`;
                })
                .finally(() => {
                    loader.hide();
                    loader = null;
                });
        },

        close() {
            document.getElementById('mediaImagePreviewImage').classList.toggle('closing');
            document.getElementById('mymodal-image').classList.toggle('closing-wo-animation');
            document.getElementById('mymodal-image').classList.remove('bg');
            setTimeout(() => this.image = null, 500);
        },

    },
}
</script>

<style scoped>
.modal-image {
    position: fixed;
    z-index: 100;
    padding-top: 100px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0);
}

.bg {
    background-color: rgba(0, 0, 0, 0.95);
    transition: 0.6s;
}

.modal-image-content {
    margin: auto;
    display: block;
    width: calc(50%);
    height: 90%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.modal-image-content {
    animation-name: zoom;
    animation-duration: 0.3s;
}

.closing {
    animation-name: unzoom;
    animation-duration: 0.6s;
    opacity: 0;
    transition: 0.5s;
}

.closing-wo-animation {
    background-color: rgba(0, 0, 0, 0.0);
    transition: 0.5s;
}


@keyframes zoom {
    from {
        transform: scale(0);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
}

@keyframes unzoom {
    from {
        transform: scale(1)
    }
    to {
        transform: scale(0)
    }
}

@media only screen and (max-width: 700px) {
    .modal-image-content {
        width: 100%;
    }
}
</style>
